var module; UMD(module, {
  'minted:m': ['M']
})(this, function (m_module) {

var M = m_module.M;

M.Config = M.Config || {};

M.Config['StoresSharedConstantsConfig'] =
{
  "section_name_max_chars": 35,
  "validation_error": {
    "unable_to_curate_product": {
      "error_code": 14
    },
    "sys_params_error": {
      "error_code": 8
    },
    "too_many_active_sections": {
      "error_code": 10
    },
    "cannot_perform_action_on_non_custom_section": {
      "error_code": 5
    },
    "session_rollback_error": {
      "error_code": 13
    },
    "section_name_too_long": {
      "error_code": 4
    },
    "duplicate_section_name_for_user": {
      "error_code": 3
    },
    "section_description_too_long": {
      "error_code": 11
    },
    "user_at_section_limit": {
      "error_code": 2
    },
    "section_name_null_or_empty": {
      "error_code": 7
    },
    "cannot_perform_action_on_active_section": {
      "error_code": 6
    },
    "product_already_uncurated": {
      "error_code": 15
    },
    "no_error": {
      "error_code": 0
    },
    "section_list_empty": {
      "error_code": 12
    },
    "unexpected_error": {
      "error_code": 1
    },
    "session_version_invalid": {
      "error_code": 9
    }
  },
  "description_max_chars": 110,
  "grid_widget_section_fns": {
    "manage_section": {
      "section_fn_names": [
        "renderActiveSections",
        "renderHiddenSections"
      ]
    },
    "manage_custom_section": {
      "section_fn_names": [
        "renderProductsInSection",
        "renderProductsNotInSection"
      ]
    },
    "store_home": {
      "section_fn_names": [
        "renderFeaturedProducts",
        "renderOtherProducts"
      ]
    },
    "search_results": {
      "section_fn_names": [
        "renderSearchResults"
      ]
    }
  },
  "grid_widget_types": {
    "manage_section": "manage_section",
    "manage_custom_section": "manage_custom_section",
    "store_home": "store_home",
    "search_results": "search_results"
  },
  "featured_artists_picks_carousel_slide_size": 4,
  "section_types": {
    "type_custom": 0,
    "type_homepage_featured_artists_picks": 2,
    "type_homepage_other_products": 3,
    "type_homepage_curated_products": 4
  },
  "auto_insert_position": {
    "top": 1,
    "bottom": 2
  }
};

return {};

});

